import React, { useState } from "react";
import {
	Box,
	Container,
	Typography,
	TextField,
	Button,
	CircularProgress,
	Alert,
} from "@mui/material";
import axios from "../api/axios";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState("");
	const { setAuth } = useAuth();
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setSuccess(false);
		setLoading(true);
		console.log(email);

		// Call mock API
		try {
			const response = await axios.post("/forgot-password", {
				email,
			});

			console.log(response);

			if (response.status === 200) {
				setSuccess(true);
				setAuth((prev) => ({ ...prev, userEmail: email }));
				navigate("/en/resetpassword");
			} else {
				// const data =  response.data;
				setError(response?.data?.message || "Something went wrong");
			}
		} catch (err) {
			if (err.response && err.response.data && err.response.data.message) {
				setError(err.response.data.message);
			} else if (err.message) {
				setError(err.message);
			} else {
				setError("Network error");
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<Container
			component="main"
			maxWidth="xs"
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				minHeight: "100vh",
				padding: 2,
			}}>
			<Box
				sx={{
					padding: 4,
					borderRadius: 2,
					boxShadow: 3,
					backgroundColor: "#fff",
				}}>
				<Typography
					variant="h5"
					gutterBottom
					align="center"
					sx={{ fontWeight: 600 }}>
					Forgot Password
				</Typography>
				<Typography variant="body2" color="textSecondary" align="center" mb={3}>
					Enter your email address to reset your password.
				</Typography>
				{success && (
					<Alert severity="success" sx={{ mb: 2 }}>
						OTP sent to your email! Please check your email.
					</Alert>
				)}
				{error && (
					<Alert severity="error" sx={{ mb: 2 }}>
						{error}
					</Alert>
				)}
				<form onSubmit={handleSubmit} noValidate>
					<TextField
						label="Email Address"
						type="email"
						fullWidth
						required
						variant="outlined"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						sx={{ mb: 2 }}
					/>
					<Button
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
						disabled={loading}
						startIcon={
							loading && <CircularProgress size={20} color="inherit" />
						}>
						{loading ? "Sending..." : "Send OTP now"}
					</Button>
				</form>
			</Box>
		</Container>
	);
};

export default ForgotPasswordPage;
